import * as React from 'react';
import {
    injectIntl,
    FormattedHTMLMessage,
    FormattedMessage,
} from 'react-intl';
import {
    VerificationService,
    ErrorId,
    ErrorResponse,
    TryAgainButtonComponent,
    FormFooterComponent,
} from '@sheerid/jslib';
import { isRenderedInIframe } from './IsRenderedInIframe';

interface StepErrorProps {
    verificationService: VerificationService;
    errorId?: ErrorId;
    intl?: any;
}

const StepError = ({ verificationService, errorId, intl }: StepErrorProps) => {
    const verificationResponse = verificationService.verificationResponse as ErrorResponse;
    const alreadyRedeemed = verificationResponse.errorIds.includes('verificationLimitExceeded');
    const renderedInIframe = isRenderedInIframe();
    const errorTitle: FormattedMessage.Props =
        alreadyRedeemed ?
        {
            id: 'alreadyRedeemedError',
            defaultMessage: 'Already Redeemed',
        } :
        {
            id: 'error',
            defaultMessage: 'Error',
        }

    return (
        <div id="sid-step-error" className={`${!renderedInIframe ? 'sid-l-container' : ''}`}>
            <div className={`sid-header__title sid-header--error sid-l-horz-center sid-l-space-top-md ${renderedInIframe ? 'sid-lightbox__title' : ''}`}>
                <FormattedHTMLMessage {...errorTitle} />
            </div>
            <div className={`sid-l-container ${renderedInIframe ? 'sid-lightbox' : ''}`}>
                <div className="sid-l-horz-center">
                    <div className="sid-header__subtitle sid-l-horz-center sid-l-space-top-md">
                        <div className="sid-error-msg sid-l-horz-center">
                            {errorId !== undefined
                                ? <FormattedHTMLMessage id={`errorId.${errorId}`} defaultMessage="Unknown Error" />
                                : null
                            }
                        </div>
                        <div className="sid-error-msg sid-l-horz-center">
                            {
                                verificationResponse.errorIds ?
                                (
                                    <p>
                                        {
                                            verificationResponse.errorIds.map(
                                                errId => intl.formatMessage({ id: `errorId.${errId}`, defaultMessage: `'${errId}'` }),
                                            ).join(', ')
                                        }
                                    </p>
                                )
                                : null
                            }
                        </div>
                        {!alreadyRedeemed && (
                            <div className="sid-l-space-top-lg sid-l-half-width sid-l-horz-center">
                                <TryAgainButtonComponent
                                    verificationService={verificationService}
                                />
                            </div>
                        )}
                    </div>
                </div>

                <div className="sid-h-small-text sid-l-horz-center">
                    <FormFooterComponent verificationService={verificationService} />
                </div>
            </div>
        </div>
    );
};

export const StepErrorComponent = injectIntl(StepError);
